import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from 'axios';
import { link } from "../ultils/variabel";
import Cookies from "universal-cookie";
import Button from 'react-bootstrap/esm/Button';
import Swal from 'sweetalert2';
import sleep from "../ultils/sleep"

const EditCategoryComponent = ({id})=> {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const [active, setActive] = useState(1);
    const [subCategory2, setSubCategory2] = useState([]);
    const [listTipe , setListTipe] = useState([]);
    const [jumlah, setJumlah] = useState(0);
    const [del, setDel] = useState([]);
    const [idc, setIdc] = useState([])

    async function updateActive(){
        let actv = active == 1 ? 0 : 1;
        let dat = {
            id : id,
            active : actv,
            token : token
        }
        let result = await axios.put(link + "admin/updateCategoryActive", dat);
        if(result.status == 200){
            Swal.fire(
                'Success',
                'Data Berhasil Di Ubah',
                'success'
              )
              sleep(1500).then(()=>{
                window.location.reload(true)
             })
        }
    }
    useEffect(()=>{
        async function callAPI() {
            await axios.get(link + "admin/getCategory?category=" + id).then(data =>{
                if(data.status == 200){
                    let cat = data.data.category;
                    let cat2 = data.data.category2;
                    setActive(cat[0].active);
                    setIdc(cat[0].id)
                    setSubCategory2(cat2);
                    setJumlah(cat2.length == 0 ? 1 : cat2.length)
                }
            });

        }
        callAPI();
    }, [])

    useEffect(()=>{
        let sb2 = [];
        let temp = [];
        for (let index = 0; index < jumlah; index++) {
            sb2.push(subCategory2[index]);
            
            temp.push((
            <div key={"ipt"+index}>
                <input type="hidden" name={"key" + index} value={sb2[index] ? sb2[index].id : ""} />
            <InputGroup className="mb-3">
            <InputGroup.Text> Sub Category1  </InputGroup.Text>
            <Form.Control 
                required={true}
                defaultValue={sb2[index] ? sb2[index].namaSubCategory1 : ""}
                name={"sb1"+index}
                aria-label="First name" 
            />
            {
            sb2[index] ? <Button 
            onClick={()=>{
                window.location.href = "editCategory1?cs="+sb2[index].namaSubCategory1
            }}
            variant='success'>Edit</Button> : ""
            }
            </InputGroup>
            </div>))
        }

        setListTipe(temp)
    }, [jumlah])

    return (
        <div className='container mt-5 mb-5'>
            <h1 className='display-4 text-center mb-3' style={{ fontSize: "40px" }}>Edit Category</h1>
        <Form action={link + "admin/updateCategory"} method="post" encType='multipart/form-data'>
            <input type="hidden" name="jumlah" value={jumlah} />
            <input type="hidden" name="del" value={del} />
            <input type="hidden" name='id' value={idc} />
                <Form.Control
                    type="file" 
                    className='mb-5'
                    name='file'/>
                    <InputGroup className='mb-5'>
                    <InputGroup.Text>Category  </InputGroup.Text>
                            <Form.Control 
                            required={true} 
                            defaultValue={id}
                            name="category"
                            aria-label="Nama" 
                            />
                    </InputGroup>
                    {listTipe}
                    <div 
        className='mb-3 linked rounded'
        onClick={()=> {
            setJumlah(jumlah - 1);
            subCategory2.pop()
            let temp = listTipe.pop();
            let tmp = del;
            tmp.push(temp.props.children[0].props.value)
            setDel(tmp)
        }} 
        style={
            {
                background : "#f02724",
                textAlign : "center"
            }
        }>-</div>
        <div 
        className='mb-3 linked rounded'
        onClick={()=> {setJumlah(jumlah + 1)}} 
        style={
            {
                background : "#dfdfdf",
                textAlign : "center"
            }
        }>+</div>




        <Button
        style={{ 
            marginRight : "15px"
        }}
        variant={active == 1 ? "danger" : "success"}
        onClick={updateActive}
        >
        {active == 1 ? "non active" : "active"}
        </Button>
        <Button variant="primary" type="submit">
            Submit
        </Button>

                    
        </Form>
    </div>
    );
}

export default EditCategoryComponent;